import React from 'react';
import telegramService from '../services/telegram';

/**
 * Ряд вкладок: подчёркивание, а не заливка. Брендбук 6.1.
 *
 * Заливка кричит громче содержимого, а синий в проекте закреплён
 * за основным действием — вкладка им краситься не должна. Второй
 * уровень отличается только кеглем: иерархия читается размером,
 * а не другим виджетом (был сегмент-контрол — чужой, iOS-ный).
 *
 * @param {Array<{id: string, label: string, count?: number}>} tabs
 * @param {string} activeId
 * @param {(id: string) => void} onChange
 * @param {boolean} sub - Второй уровень: 14px вместо 16px
 */
const Tabs = ({ tabs, activeId, onChange, sub = false, className = '' }) => (
  <div
    role="tablist"
    // Полоса-подложка идёт во всю ширину ряда, сам ряд скроллится:
    // вкладок может стать больше, чем влезает в экран
    className={`flex overflow-x-auto scrollbar-hide border-b border-theme-border ${sub ? 'gap-4' : 'gap-5'} ${className}`}
  >
    {tabs.map(tab => {
      const active = tab.id === activeId;
      return (
        <button
          key={tab.id}
          role="tab"
          aria-selected={active}
          onClick={() => {
            if (active) return;
            telegramService.hapticFeedback('light');
            onChange(tab.id);
          }}
          className={[
            'relative flex-shrink-0 whitespace-nowrap border-0 bg-transparent',
            'transition-colors duration-fast ease-out',
            sub ? 'text-body-sm min-h-[38px] pb-[9px]' : 'text-body min-h-[44px] pb-[11px]',
            active
              ? 'font-semibold text-theme-text-primary'
              : 'font-medium text-theme-text-secondary',
          ].join(' ')}
          style={{ WebkitTapHighlightColor: 'transparent' }}
        >
          {tab.label}
          {typeof tab.count === 'number' && (
            // Число приглушено, чтобы не спорить с названием вкладки
            <span
              className={`tabular ml-[5px] text-caption font-medium ${
                active ? 'text-theme-text-secondary' : 'text-theme-text-hint'
              }`}
            >
              {tab.count}
            </span>
          )}
          {active && (
            <span
              aria-hidden="true"
              className="absolute left-0 right-0 -bottom-px h-0.5 rounded-sm bg-action"
            />
          )}
        </button>
      );
    })}
  </div>
);

export default Tabs;
